<template>
  <div ref="activities">
    <v-row>
      <v-col class="d-flex" cols="12" sm="6" md="4" v-for="(campaign, index) in displays" :key="index">
        <v-hover v-slot="{ hover }">
          <v-card :elevation="hover ? 5 : 2" @click="toCampaign(campaign)">
            <div class="activity-image">
              <v-img :src="`${campaign.picBigHomeThumbnail}`" style="z-index:0">
              </v-img>
            </div>
            <div class="activity-content pa-3 pa-md-4">
              <div class="text-title" style="z-index:5">
                {{ campaign.title }}
              </div>
              <div class="mt-2" style="min-height:19.2px">
                <v-icon color="primary" class="mr-1" small>mdi-calendar</v-icon>
                <span class="grey--text text--darken-1">{{ activityPeriod(campaign) }}</span>
              </div>
            </div>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
    <div v-if="isRendering" class="text-center">
      <ProgressCircular />
    </div>
    <template v-else>
      <div v-if="!isRendering && (currentPage === totalPage || displays.length === campaigns.length)"
        class="text-center pa-3 text-small mt-6">
        {{ $t('index_no_more_activity') }}
      </div>
      <div v-else-if="currentPage === 0">
        <v-btn depressed class="d-block mt-4" color="primary-1--text" width="100%" large
          @click="() => { this.isRendering = true; this.currentPage += 1; this.getDisplayItems(); }">
          {{ $t('index_more_activity') }}
        </v-btn>
      </div>
    </template>
  </div>
</template>

<script>
var lastScrollTop = 0;
import padLeft from "@/vendor/padLeft";

export default {
  props: {
    campaigns: {
      type: Array,
      default: []
    }
  },
  watch: {
    campaigns(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.displays = []
        this.isRendering = true;
        this.currentPage = 0;
        this.totalPage = Math.ceil(newVal.length / 6);
        this.getDisplayItems();
      }
    }
  },
  data() {
    return {
      isRendering: true,
      perPage: 6,
      currentPage: 0,
      totalPage: Math.ceil(this.campaigns.length / 6),
      displays: []
    }
  },
  methods: {
    countDate(startDate) {
      const start = (new Date(startDate));
      const today = (new Date());

      if (today.valueOf() >= start.valueOf()) {
        return this.$t('list_activity_today');
      } else {
        let m = start.getMonth() + 1;
        return `${start.getFullYear()}-${padLeft(String(m), 2)}-${padLeft(String(start.getDate()), 2)}`;
      }
    },
    activityPeriod(campaign) {
      if (campaign.start_date === campaign.end_date) {
        return campaign.start_date
      } else {
        return `${this.countDate(campaign.start_date)} ${this.$t('list_activity_to')} ${campaign.end_date}`
      }
    },
    toCampaign(campaign) {
      this.$router.push({
        name: "Activity",
        params: { id: campaign.event_id }
      }).catch(() => { });
    },
    getDisplayItems() {
      const campaigns = [...this.campaigns];
      const activities = campaigns.splice(this.currentPage * this.perPage, this.perPage);

      setTimeout(() => {
        this.displays = [...this.displays, ...activities];
        this.isRendering = false;
      }, 1000);
    },
    detectScrollPosition() {
      if (this.isRendering || this.currentPage === 0) return;
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      const isScrollDown = currentScroll > lastScrollTop;
      const refs = this.$refs.activities;
      const rect = refs.getBoundingClientRect();
      const limit = (window.innerHeight || document.documentElement.clientHeight) - 100;

      if (isScrollDown && rect.bottom <= limit && this.currentPage + 1 < this.totalPage && !this.isRendering) {
        this.isRendering = true;
        this.currentPage++;
        // console.log(`isRendering: ${this.currentPage}/${this.totalPage},  Length: ${this.displays.length}/${this.campaigns.length}, Bottom: ${limit - rect.bottom} `);
        this.getDisplayItems();
      }
    }
  },
  mounted() {
    this.getDisplayItems();
    window.addEventListener('scroll', this.detectScrollPosition);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.detectScrollPosition);
  }
};
</script>

<style lang="scss" scoped>
.row {
  margin-left: -6px;
  margin-right: -6px;

  @media screen and (min-width: 600px) {
    margin-left: -8px;
    margin-right: -8px;
  }

  @media screen and (min-width: 960px) {
    margin-left: -12px;
    margin-right: -12px;
  }

  >[class*='col-'] {
    padding: 6px;

    @media screen and (min-width: 600px) {
      padding: 8px;
    }

    @media screen and (min-width: 960px) {
      padding: 10px;
    }
  }
}

.activity-image {
  position: relative;
  padding-bottom: 62.38%;
  overflow: hidden;
  border-radius: $radiusDesktop $radiusDesktop 0 0;

  .v-image {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  @media screen and (max-width: 768px) {
    border-radius: $radiusMobile $radiusMobile 0 0;
  }
}

.v-card {
  display: flex;
  flex-direction: column;
  flex: 1;
  flex-grow: 1;
  width: 100%;

  .activity-content {
    flex: 1;
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    .text-title {
      display: block;
      display: -webkit-box;
      height: 2em;
      line-clamp: 2;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
      flex: 1;
      flex-grow: 1;
    }
  }
}

.coverImage {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
}

.title-shadow {
  width: 100%;
  height: 33%;
  position: absolute;
  bottom: 0;
  background-image: linear-gradient(to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.7));
}
</style>
